"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTaskHttpClient = void 0;
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class UserTaskHttpClient extends BaseClient_1.BaseClient {
    async query(query, identity, offset, limit, sortSettings) {
        const enhancedQuery = {
            ...query,
            flowNodeType: atlas_engine_sdk_1.BpmnType.userTask,
        };
        const url = this.buildUrl(index_1.restSettings.paths.queryFlowNodeInstances, offset, limit, enhancedQuery, sortSettings);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            userTasks: response.result.flowNodeInstances.map(Mappers_1.mapUserTask),
        };
        return mappedResult;
    }
    async reserveUserTaskInstance(identity, flowNodeInstanceId, actualOwnerId) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.reserveUserTaskInstance
            .replace(index_1.restSettings.params.userTaskInstanceId, flowNodeInstanceId);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.put(url, { actualOwnerId: actualOwnerId }, requestAuthHeaders);
    }
    async cancelUserTaskInstanceReservation(identity, flowNodeInstanceId) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.cancelUserTaskInstanceReservation
            .replace(index_1.restSettings.params.userTaskInstanceId, flowNodeInstanceId);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.delete(url, requestAuthHeaders);
    }
    async finishUserTask(userTaskInstanceId, userTaskResult, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.finishUserTask
            .replace(index_1.restSettings.params.userTaskInstanceId, userTaskInstanceId);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.put(url, userTaskResult, requestAuthHeaders);
    }
    async onUserTaskWaiting(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.userTaskWaiting, callback, subscribeOnce, identity);
    }
    async onUserTaskFinished(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.userTaskFinished, callback, subscribeOnce, identity);
    }
    async onUserTaskReserved(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.userTaskReserved, callback, subscribeOnce, identity);
    }
    async onUserTaskReservationCanceled(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.userTaskReservationCanceled, callback, subscribeOnce, identity);
    }
    async removeSubscription(identity, subscription) {
        this.removeSocketIoSubscription(identity, subscription);
    }
}
exports.UserTaskHttpClient = UserTaskHttpClient;
//# sourceMappingURL=UserTaskHttpClient.js.map